// extracted by mini-css-extract-plugin
module.exports = {"masonry":"masonry--D0Z4zDnaz7"};